(function () {
  /** Match the player's encoding so we can compare against the global <audio> src. */
  function encodeAudioUrl(url) {
    return url ? String(url).replace(/#/g, '%23') : '';
  }

  function panelProductInfo(panel) {
    return {
      productUrl: panel.getAttribute('data-product-url') || '',
      image: panel.getAttribute('data-product-image') || '',
      variantId: panel.getAttribute('data-variant-id') || '',
      title: panel.getAttribute('data-product-title') || ''
    };
  }

  /**
   * Turn a preview row's button into a global Audio Player trigger so playback
   * runs through the shared bottom bar (single-track scope, like bundle cells).
   */
  function ensureTrigger(panel, row, btn) {
    if (btn._ugTriggerReady) return true;
    var src = encodeAudioUrl(row.getAttribute('data-ug-preview-src') || '');
    if (!src) return false;
    var info = panelProductInfo(panel);
    var nameEl = row.querySelector('.ug-preview-track__name');
    var label = nameEl ? nameEl.textContent.trim() : info.title;
    btn.setAttribute('data-ug-audio-src', src);
    btn.setAttribute('data-ug-audio-title', label || info.title || '');
    if (info.image) btn.setAttribute('data-ug-audio-image', info.image);
    if (info.productUrl) btn.setAttribute('data-ug-audio-product-url', info.productUrl);
    if (info.variantId) btn.setAttribute('data-ug-audio-variant-id', info.variantId);
    btn.setAttribute('data-ug-audio-scope', 'single');
    btn._ugTriggerReady = true;
    return true;
  }

  function currentSrc(globalAudio) {
    if (!globalAudio) return '';
    return globalAudio.currentSrc || globalAudio.getAttribute('src') || '';
  }

  function srcMatches(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    try {
      return decodeURIComponent(a) === decodeURIComponent(b);
    } catch (e) {
      return false;
    }
  }

  // Reflect the shared player's state onto a single panel's preview rows.
  function syncPanelRows(panel) {
    var globalAudio = document.getElementById('ug-audio-element');
    var playVerb = panel.getAttribute('data-preview-play-verb') || 'Play';
    var pauseVerb = panel.getAttribute('data-preview-pause-verb') || 'Pause';
    var src = currentSrc(globalAudio);
    var playing = globalAudio && !globalAudio.paused;
    panel.querySelectorAll('.ug-preview-track').forEach(function (row) {
      var rowSrc = encodeAudioUrl(row.getAttribute('data-ug-preview-src') || '');
      var active = !!playing && !!rowSrc && srcMatches(src, rowSrc);
      row.classList.toggle('is-playing', active);
      var btn = row.querySelector('.ug-preview-track__btn');
      if (!btn) return;
      var nameEl = row.querySelector('.ug-preview-track__name');
      var name = nameEl ? nameEl.textContent.trim() : '';
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', (active ? pauseVerb : playVerb) + ': ' + name);
    });
  }

  /**
   * Bind the global <audio> listeners ONCE. On each event we sync every panel
   * currently in the DOM, so panels added by later page swaps work without
   * stacking listeners on the persistent audio element.
   */
  var globalSyncBound = false;
  function ensureGlobalSync() {
    if (globalSyncBound) return;
    var globalAudio = document.getElementById('ug-audio-element');
    if (!globalAudio) return;
    globalSyncBound = true;
    var syncAll = function () {
      document.querySelectorAll('.ug-product-preview-panel').forEach(syncPanelRows);
    };
    ['play', 'pause', 'ended', 'emptied', 'loadedmetadata'].forEach(function (ev) {
      globalAudio.addEventListener(ev, syncAll);
    });
    window.__ugPreviewSyncAll = syncAll;
  }

  function initPanel(panel) {
    if (panel._ugPreviewInited) {
      return;
    }
    panel._ugPreviewInited = true;

    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('.ug-preview-track__btn');
      if (!btn || !panel.contains(btn)) return;

      var row = btn.closest('.ug-preview-track');
      if (!row) return;
      if (!row.getAttribute('data-ug-preview-src')) return;

      e.preventDefault();
      if (!ensureTrigger(panel, row, btn)) return;
      if (typeof window.ugAudioPlayerPlayFromButton === 'function') {
        window.ugAudioPlayerPlayFromButton(btn);
      }
    });

    ensureGlobalSync();
    syncPanelRows(panel);
  }

  function labelFromFile(handle, file) {
    var p = 'undrgrnd_' + handle + '_';
    var base = file.indexOf(p) === 0 ? file.slice(p.length) : file.replace(/^undrgrnd_[a-z0-9-]+_/i, '');
    return base
      .replace(/\.(mp3|wav|mpeg|m4a)$/i, '')
      .replace(/_/g, ' ')
      .trim();
  }

  function buildTrackRow(fileKeyHandle, item, index, playVerb) {
    var file = item.file;
    var url = item.url;
    // An explicit label wins. Needed for curated cross-pack lists, where the
    // filename belongs to another pack so labelFromFile cannot strip it — and
    // for packs whose files are not named `undrgrnd_<handle>_...` at all.
    var label = item.label || labelFromFile(fileKeyHandle, file);
    var row = document.createElement('div');
    row.className = 'ug-preview-track';
    row.setAttribute('data-ug-preview-index', String(index));
    row.setAttribute('data-ug-preview-src', url);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ug-preview-track__btn';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', playVerb + ': ' + label);
    btn.innerHTML =
      '<span class="ug-preview-track__btn-ring" aria-hidden="true"></span>' +
      '<span class="ug-preview-track__btn-glyph ug-preview-track__btn-glyph--play" aria-hidden="true"></span>' +
      '<span class="ug-preview-track__btn-glyph ug-preview-track__btn-glyph--pause" aria-hidden="true"></span>';

    var body = document.createElement('div');
    body.className = 'ug-preview-track__body';
    var nameEl = document.createElement('p');
    nameEl.className = 'ug-preview-track__name';
    nameEl.textContent = label;

    var wave = document.createElement('div');
    wave.className = 'ug-preview-waveform';
    wave.setAttribute('aria-hidden', 'true');
    var barsWrap = document.createElement('div');
    barsWrap.className = 'ug-preview-waveform__bars';
    for (var i = 0; i < 48; i++) {
      var m = i % 9;
      var span = document.createElement('span');
      span.className = 'ug-preview-waveform__bar ug-preview-waveform__bar--' + m;
      barsWrap.appendChild(span);
    }
    wave.appendChild(barsWrap);
    body.appendChild(nameEl);
    body.appendChild(wave);
    row.appendChild(btn);
    row.appendChild(body);
    return row;
  }

  function loadManifest(url) {
    if (!window.__ugPreviewManifestCache) {
      window.__ugPreviewManifestCache = {};
    }
    if (window.__ugPreviewManifestCache[url]) {
      return Promise.resolve(window.__ugPreviewManifestCache[url]);
    }
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('manifest');
        return r.json();
      })
      .then(function (json) {
        window.__ugPreviewManifestCache[url] = json;
        return json;
      });
  }

  /**
   * Resolve JSON key for this product (handle may omit "-and-" vs filenames).
   */
  function resolveManifestKey(manifest, handle) {
    if (!manifest || !handle) return null;
    if (manifest[handle] && manifest[handle].length) return handle;
    var norm = function (s) {
      return String(s).replace(/-and-/g, '-');
    };
    var h0 = norm(handle);
    for (var k in manifest) {
      if (Object.prototype.hasOwnProperty.call(manifest, k) && norm(k) === h0 && manifest[k].length) {
        return k;
      }
    }
    return null;
  }

  function mountFromManifest(panel, manifest, handleOverride) {
    var handle = handleOverride || panel.getAttribute('data-product-handle');
    var list = panel.querySelector('[data-ug-preview-list]');
    if (!handle || !list) return false;

    var key = resolveManifestKey(manifest, handle);
    if (!key) return false;

    var tracks = manifest[key];
    if (!tracks || !tracks.length) return false;

    return mountFromTrackList(panel, tracks, key);
  }

  function isBundlePreviewPanel(panel) {
    return (
      panel.getAttribute('data-bundle-preview') === 'true' ||
      !!panel.closest('.und-bundle-product')
    );
  }

  /**
   * Bundles: preview loops from the first pack linked in the product description.
   */
  function mountBundlePreviewFromFirstPack(panel, previewManifest) {
    var bundleHandle = panel.getAttribute('data-product-handle');
    var contentsUrl =
      panel.getAttribute('data-bundle-contents-url') ||
      (typeof window.UG_BUNDLE_CONTENTS_MANIFEST_URL === 'string'
        ? window.UG_BUNDLE_CONTENTS_MANIFEST_URL
        : '');

    if (!bundleHandle || !contentsUrl) return Promise.resolve(false);

    return loadManifest(contentsUrl)
      .then(function (bundleContents) {
        var entry = bundleContents && bundleContents[bundleHandle];
        if (!entry || !entry.handles || !entry.handles.length) return false;

        var firstPack = entry.handles[0];
        var key = resolveManifestKey(previewManifest, firstPack);
        if (!key) return false;

        var tracks = previewManifest[key];
        if (!tracks || !tracks.length) return false;

        var packTitle =
          (entry.titles && entry.titles[firstPack]) || firstPack.replace(/-/g, ' ');
        panel.setAttribute('data-bundle-preview-pack', firstPack);
        panel.setAttribute('data-bundle-preview-pack-title', packTitle);

        return mountFromTrackList(panel, tracks, key);
      })
      .catch(function () {
        return false;
      });
  }

  function mountFromTrackList(panel, tracks, defaultKey) {
    var list = panel.querySelector('[data-ug-preview-list]');
    if (!list || !tracks || !tracks.length) return false;

    var playVerb = panel.getAttribute('data-preview-play-verb') || 'Play';
    list.textContent = '';
    for (var i = 0; i < tracks.length; i++) {
      var key = tracks[i].packKey || tracks[i].packHandle || defaultKey || 'bundle';
      list.appendChild(buildTrackRow(key, tracks[i], i + 1, playVerb));
    }
    panel.classList.add('ug-product-preview-panel--from-manifest');
    return true;
  }

  function bootBundlePanel(panel) {
    var url = panel.getAttribute('data-bundle-preview-url');
    if (!url) {
      initPanel(panel);
      return Promise.resolve();
    }
    return loadManifest(url)
      .then(function (data) {
        var tracks = (data && data.tracks) || [];
        if (tracks.length) {
          mountFromTrackList(panel, tracks, 'bundle');
        }
        initPanel(panel);
      })
      .catch(function () {
        initPanel(panel);
      });
  }

  window.ugBootBundlePreviewPanel = bootBundlePanel;

  function boot() {
    var panels = document.querySelectorAll('.ug-product-preview-panel[data-manifest-url]');
    panels.forEach(function (panel) {
      var url = panel.getAttribute('data-manifest-url');
      if (!url) {
        initPanel(panel);
        return;
      }
      loadManifest(url)
        .then(function (manifest) {
          if (isBundlePreviewPanel(panel)) {
            // Prefer an explicit curated preview list keyed by the bundle's own
            // handle (e.g. a hand-picked cross-pack selection); otherwise fall
            // back to the first linked pack's previews.
            if (mountFromManifest(panel, manifest)) {
              initPanel(panel);
              return;
            }
            return mountBundlePreviewFromFirstPack(panel, manifest).then(function (mounted) {
              if (!mounted) mountFromManifest(panel, manifest);
              initPanel(panel);
            });
          }
          if (mountFromManifest(panel, manifest)) {
            initPanel(panel);
          } else {
            initPanel(panel);
          }
        })
        .catch(function () {
          initPanel(panel);
        });
    });

    document.querySelectorAll('[data-bundle-preview-url]').forEach(function (panel) {
      if (panel.closest('[hidden]')) return;
      bootBundlePanel(panel);
    });
  }

  // Exposed so instant-navigation (Swup) can re-boot preview panels after a page swap.
  window.ugBootPreviewPanels = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
